import React from 'react';
import PeopleSearchSuggestedPersonItem from './people_search_suggested_person';
import PropTypes from 'prop-types';
import { PeopleSearchShape } from '../shapes';
import Downshift from 'downshift';

export default class PeopleSearch extends React.Component {
  static propTypes = {
    peopleSearchObject: PeopleSearchShape,
    onSearch: PropTypes.func
  }

  state = {
    timeout: undefined,
    peopleText: undefined,
    peopleSlug: undefined
  };


  onKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  render() {
    return (
      <div className='word-search'>
        <Downshift
          onInputValueChange={ this.onSearchInputChange }
          render={({
            getInputProps,
            getItemProps,
            highlightedIndex,
            isOpen
          }) => (
            <div className='row'>
              <div className='col-sm-12'>
                <input { ...getInputProps({
                    onKeyDown: this.onKeyDown.bind(this),
                    type: 'text',
                    className: 'input-text search',
                    placeholder: "Start typing a person's name...",
                  }) }
                />
                {isOpen ? (
                  <div className='suggested-search-results'>
                    {this.props.peopleSearchObject.get('suggestedPeople').map((suggestedPerson, i) => (
                      <PeopleSearchSuggestedPersonItem key={ i } user={ suggestedPerson } downshiftItemProps={ getItemProps } index={ i } currentIndex={ highlightedIndex } />
                    ))}
                   </div>
                ) : null }
              </div>
            </div>
          )}
        />
    </div>
    );
  }

  onTyping(peopleText) {
    if (this.state.timeout) {
      clearTimeout(this.state.timeout);
    }
    const timeout = setTimeout(() => {
      if (peopleText.length > 2) {
        this.props.onSearch(peopleText);
      }
    }, 500);
    this.setState({ timeout: timeout });
  }

  onSearchInputChange = (peopleText) => {
    if (peopleText && peopleText.length > 0) {
      this.onTyping(peopleText);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/people_search.jsx